"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
var BillingApiAccountResponseDto_1;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiAccountResponseDto = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const swagger_1 = require("../../../../swagger-fake");
const billing_api_fn_1 = require("../../../../billing-api/shared/billing-api-fn");
const transform_iso8601_date_1 = __importDefault(require("../../../../shared/pipes/transform-iso8601-date"));
const billing_api_contractor_response_dto_1 = require("../../../billing-api-contractor/types/dtos/billing-api-contractor-response.dto");
const billing_api_account_dto_1 = require("./billing-api-account.dto");
const billing_api_bank_account_response_dto_1 = require("./billing-api-bank-account-response.dto");
const billing_api_card_account_response_dto_1 = require("./billing-api-card-account-response.dto");
let BillingApiAccountResponseDto = BillingApiAccountResponseDto_1 = class BillingApiAccountResponseDto extends billing_api_account_dto_1.BillingApiAccountDto {
  static fromAccount(values) {
    const instance = (0, class_transformer_1.plainToInstance)(BillingApiAccountResponseDto_1, values);
    return instance;
  }
};
__decorate([(0, swagger_1.ApiProperty)({
  description: "Id счёта",
  format: "uuid",
  readOnly: true
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsUUID)(4), __metadata("design:type", String)], BillingApiAccountResponseDto.prototype, "id", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Баланс счёта",
  format: "decimal",
  default: "0.000000",
  readOnly: true
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsDecimal)(), __metadata("design:type", String)], BillingApiAccountResponseDto.prototype, "balance", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Сумма по кредиту",
  format: "decimal",
  default: "0.000000",
  readOnly: true
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsDecimal)(), __metadata("design:type", String)], BillingApiAccountResponseDto.prototype, "sumCredit", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Сумма по дебету",
  format: "decimal",
  default: "0.000000",
  readOnly: true
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsDecimal)(), __metadata("design:type", String)], BillingApiAccountResponseDto.prototype, "sumDebit", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Заблокированный баланс счёта",
  format: "decimal",
  default: "0.000000",
  readOnly: true
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsDecimal)(), __metadata("design:type", String)], BillingApiAccountResponseDto.prototype, "holdBalance", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Дата создания",
  format: "date-time"
}), (0, class_transformer_1.Expose)(), (0, transform_iso8601_date_1.default)(), (0, class_validator_1.IsDate)(), __metadata("design:type", Date)], BillingApiAccountResponseDto.prototype, "createdAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Дата обновления",
  format: "date-time"
}), (0, class_transformer_1.Expose)(), (0, transform_iso8601_date_1.default)(), (0, class_validator_1.IsDate)(), __metadata("design:type", Date)], BillingApiAccountResponseDto.prototype, "updatedAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: `Связанная со счётом карта, если есть 
    (доступно при использовании include-опций запроса)`,
  ...(0, billing_api_fn_1.swaggerRef)('BillingApiCardAccountResponseDto')
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.ValidateNested)(), (0, class_transformer_1.Type)(() => billing_api_card_account_response_dto_1.BillingApiCardAccountResponseDto), __metadata("design:type", billing_api_card_account_response_dto_1.BillingApiCardAccountResponseDto)], BillingApiAccountResponseDto.prototype, "cardAccount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: `Связанные со счётом банковские реквизиты, 
    если есть (доступно при использовании include-опций запроса)`,
  ...(0, billing_api_fn_1.swaggerRef)('BillingApiBankAccountResponseDto')
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.ValidateNested)(), (0, class_transformer_1.Type)(() => billing_api_bank_account_response_dto_1.BillingApiBankAccountResponseDto), __metadata("design:type", billing_api_bank_account_response_dto_1.BillingApiBankAccountResponseDto)], BillingApiAccountResponseDto.prototype, "bankAccount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: `Контрагент (доступно при использовании include-опций запроса)`,
  ...(0, billing_api_fn_1.swaggerRef)('BillingApiContractorResponseDto')
}), (0, class_transformer_1.Expose)(), __metadata("design:type", billing_api_contractor_response_dto_1.BillingApiContractorResponseDto)], BillingApiAccountResponseDto.prototype, "contractor", void 0);
BillingApiAccountResponseDto = BillingApiAccountResponseDto_1 = __decorate([(0, swagger_1.ApiExtraModels)(billing_api_bank_account_response_dto_1.BillingApiBankAccountResponseDto), (0, swagger_1.ApiExtraModels)(billing_api_card_account_response_dto_1.BillingApiCardAccountResponseDto), (0, class_transformer_1.Exclude)()], BillingApiAccountResponseDto);
exports.BillingApiAccountResponseDto = BillingApiAccountResponseDto;
